import { useState } from "react";
import { ArrowDown, ArrowUp, ArrowUpDown, Search } from "lucide-react";
import { parseDateFilter, parseAmountInput } from "@/lib/rows";

const COLS = [
  { id: "op", label: "Data operazione", type: "date", w: "w-[170px]" },
  { id: "val", label: "Data valuta", type: "date", w: "w-[170px]" },
  { id: "desc", label: "Descrizione", type: "text", w: "" },
  { id: "deb", label: "Addebiti", type: "amount", w: "w-[160px]", right: true },
  { id: "cred", label: "Accrediti", type: "amount", w: "w-[160px]", right: true },
];

const PLACEHOLDER = { date: "gg/mm/aaaa", text: "Cerca nella descrizione…", amount: "Importo esatto" };
const TITLE = {
  date: "Giorno (03/04/2024), mese (04/2024) o periodo (01/04/2024 - 15/04/2024)",
  text: "Tutte le parole devono comparire nella descrizione",
  amount: "Importo esatto, es. 110,93 o 1.234,56",
};

const isInvalid = (type, v) =>
  (type === "date" && parseDateFilter(v) === "invalid") || (type === "amount" && Number.isNaN(parseAmountInput(v)));

const InlineInput = ({ id, type, value, onChange }) => {
  const [focused, setFocused] = useState(false);
  const right = type === "amount";
  const bad = value && !focused && isInvalid(type, value);
  return (
    <div className="relative mt-2">
      {type === "text" && <Search className="absolute left-2 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-slate-400" />}
      <input data-testid={`filter-${id}`} value={value} onChange={(e) => onChange(e.target.value)} placeholder={PLACEHOLDER[type]}
        onFocus={() => setFocused(true)} onBlur={() => setFocused(false)}
        title={TITLE[type]} inputMode={right ? "decimal" : "text"} aria-invalid={!!bad}
        className={`h-8 w-full rounded-md border bg-white pr-2 text-xs font-normal text-slate-800 outline-none ${type === "text" ? "pl-7" : "pl-2"} ${type !== "text" ? "font-mono" : ""} ${right ? "text-right" : ""} ${bad ? "border-red-400 focus:border-red-500" : value ? "border-emerald-500" : "border-slate-200 focus:border-emerald-500"}`} />
    </div>
  );
};

const SortIcon = ({ sort, id }) => {
  if (sort?.col !== id) return <ArrowUpDown className="h-3.5 w-3.5 opacity-40" />;
  return sort.dir === "asc" ? <ArrowUp className="h-3.5 w-3.5" /> : <ArrowDown className="h-3.5 w-3.5" />;
};

export const GridHeader = ({ filters, setFilter, sort, onSort }) => (
  <thead className="sticky top-0 z-10 bg-slate-100 text-xs text-slate-600">
    <tr>
      <th className="w-12 border-b border-r border-slate-200 px-2 py-2 text-center font-mono font-normal text-slate-400">#</th>
      {COLS.map((c) => (
        <th key={c.id} className={`${c.w} border-b border-r border-slate-200 px-3 py-2 font-semibold align-top`}>
          <div className={`flex items-center gap-1 ${c.right ? "justify-end" : ""}`}>
            <button type="button" data-testid={`sort-${c.id}`} onClick={() => onSort(c.id)} className="inline-flex items-center gap-1.5 hover:text-slate-900">
              {c.label} <SortIcon sort={sort} id={c.id} />
            </button>
          </div>
          <InlineInput id={c.id} type={c.type} value={filters[c.id]} onChange={(v) => setFilter(c.id, v)} />
        </th>
      ))}
    </tr>
  </thead>
);
